interface MerchantState {
  merchantList: Merchant[];
  merchantSelect: SelectItem<number>[];
  voucherDisplayTypes: SelectItem<number>[];
  categories: MerchantCategory[];
}

export const merchantState = (): MerchantState => ({
  merchantList: [],
  merchantSelect: [],
  voucherDisplayTypes: [
    {
      value: 0,
      text: '無',
    },
    {
      value: 1,
      text: 'barcode',
    },
    {
      value: 2,
      text: 'QRcode',
    },
    {
      value: 4,
      text: '網頁',
    },
    {
      value: 8,
      text: '電子憑證(檔案)',
    },
    {
      value: 16,
      text: '序號',
    },
    {
      value: 32,
      text: '實體商品',
    },
    {
      value: 128,
      text: '正掃 (使用者掃碼)',
    },
  ],
  categories: [],
});

export const actions = {
  setMerchantList({ commit }: any, merchantList: Merchant[]) {
    commit('setMerchantList', merchantList);
    commit('setMerchantSelect', merchantList);
  },
  setMerchantCategories({ commit }: any, categories: MerchantCategory[]) {
    commit('setMerchantCategories', categories);
  },
};

export const mutations = {
  setMerchantList(state: any, merchantList: Merchant[]) {
    state.merchantList = merchantList;
  },
  setMerchantSelect(state: any, merchantList: Merchant[]) {
    state.merchantSelect = merchantList.map((merchant) => ({
      text: merchant.merchantName,
      value: merchant.merchantId,
    }));
  },
  setMerchantCategories(state: any, categories: MerchantCategory[]) {
    state.categories = categories;
  },
};

export default {
  namespaced: true,
  state: merchantState,
  actions,
  mutations,
};
